import { Box, Stack, Typography } from '@mui/material';

export default function PageBaseLayout({
  title,
  actions,
  children,
}: Readonly<{
  title: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}>) {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {title}
        </Typography>
        {actions}
      </Stack>
      {children}
    </Box>
  );
}
